import { useSelector } from 'react-redux';

export const GetAccessByPermissions = (group) => {
  const allPrivileges = useSelector((state) => state.common.casls);
  const objectIds = Object.values(group.childrenObjects).map((object) => object.id);
  return allPrivileges.some((privilege) => objectIds.includes(privilege.object));
};
